import React from 'react';
import '../styles/authLoader.css';

const AuthLoader = ({ error }) => {
  return (
    <div className="auth-loader-screen">
      <div className="auth-loader-cup-wrap" aria-hidden="true">
        <div className="auth-loader-cup">
          <div className="auth-loader-coffee" />
        </div>
        <div className="auth-loader-handle" />
      </div>

      <div className="auth-loader-title">Подключаем Quickly Coffee...</div>
      <div className="auth-loader-subtitle">Проверяем авторизацию</div>

      {error ? <div className="auth-loader-error">{error}</div> : null}
    </div>
  );
};

export default AuthLoader;
